export const testCSVData = () => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve({
        records: [
          {
            buildId: 11777,
            neighborhoodId: 193,
            neighborhoodDescription: 'Natures Cove West Phase 2',
            lotNumber: 1,
            lotPremium: 0.0,
            planDescription: 'Shackleford II F',
            basePrice: 476799.0,
            jobCode: '227020001',
            block: 'B',
            upgradePrice: 16616.0,
            totalPrice: 493415.0,
            age: 110,
            territory: 'Athens',
            plan: 'Shackleford II F',
            createdDate: '2023-01-20T00:00:00',
            modifiedDateTime: '2023-01-20T12:00:00',
            categories: ['List Item 1', 'List Item 2', 'List Item 3'],
            subCategories: ['List Item 1', 'List Item 2', 'List Item 3']
          },
          {
            buildId: 9793,
            neighborhoodId: 165,
            neighborhoodDescription: 'Northwoods Phase 0',
            lotNumber: 57,
            lotPremium: 0.0,
            planDescription: 'Brunswick E',
            basePrice: 470717.0,
            jobCode: '220000057',
            block: '',
            upgradePrice: 9182.82,
            totalPrice: 479899.82,
            age: 550,
            territory: 'Auburn',
            plan: 'Brunswick E',
            createdDate: '2023-01-10T00:00:00',
            modifiedDateTime: '2023-01-30T08:00:00',
            categories: ['List Item 1', 'List Item 2', 'List Item 4'],
            subCategories: ['List Item 1', 'List Item 2', 'List Item 4']
          },
          {
            buildId: 9793,
            neighborhoodId: 165,
            neighborhoodDescription: 'Northwoods Phase 0',
            lotNumber: 57,
            lotPremium: 0.0,
            planDescription: 'Brunswick F',
            basePrice: 470717.0,
            jobCode: '220000057',
            block: '',
            upgradePrice: 9182.82,
            totalPrice: 479899.82,
            age: 550,
            territory: 'Auburn Test',
            plan: 'Brunswick F',
            createdDate: '2023-02-08T00:00:00',
            modifiedDateTime: '2023-02-30T08:00:00',
            categories: [],
            subCategories: ['List Item 1', 'List Item 2', 'List Item 4']
          }
        ],
        totalCount: 2
      });
    }, 1000);
  });
};
